import script from "./StructureDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureDrawer.vue?vue&type=script&setup=true&lang=js"

import "./StructureDrawer.vue?vue&type=style&index=0&id=5311b807&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5311b807"]])

export default __exports__